import { useState } from "react";
import { Box, Container, Stack, Typography } from "@mui/material";
import { getConfig } from "services/config.service";
import { useTheme } from "@mui/material/styles";
import { useSiteInformation } from "./hooks/useSiteInformationQueries";
import { DialogComponent } from "../dialogs/dialog.component";
import { Grid, IconButton } from "@mui/material";
import CopyIcon from "@mui/icons-material/ContentCopyOutlined";
import { SwaggerLink } from "./footer.style";

export const FooterComponent = () => {
  const [showVersionInfo, setShowVersionInfo] = useState(false);
  const { data: siteInfo } = useSiteInformation();
  const theme = useTheme();

  const softwareVersion = siteInfo?.version ?? "";
  const environmentName = siteInfo?.environment ?? "";

  const copyVersionsToClipboard = () => {
    navigator.clipboard.writeText(
      `Frontend-Version: ${import.meta.env.VITE_VERSION}
        Backend-Version: ${softwareVersion}
        Umgebung: ${environmentName}`,
    );
  };

  const renderDialog = () => {
    return (
      <DialogComponent
        title={"Versionsinformationen"}
        isOpen={showVersionInfo}
        options={[
          {
            title: "Schließen",
            handleOption: () => {
              setShowVersionInfo(false);
            },
          },
        ]}
        onClose={() => {
          setShowVersionInfo(false);
        }}
      >
        <Grid container width={"300px"}>
          <Grid size={7}>
            <Stack spacing={2}>
              <div>Frontend-Version:</div>
              <div>Backend-Version:</div>
              <div>Umgebung:</div>
            </Stack>
          </Grid>
          <Grid size={3} sx={{ color: theme.custom.colors.mediDarkerGray }}>
            <Stack spacing={2}>
              <div title={import.meta.env.VITE_VERSION}>{import.meta.env.VITE_VERSION}</div>
              <div title={softwareVersion}>
                {softwareVersion.length > 10
                  ? softwareVersion.substring(0, 10) + "..."
                  : softwareVersion}
              </div>
              <div title={environmentName}>{environmentName}</div>
            </Stack>
          </Grid>
          <Grid size={2}>
            <IconButton
              sx={{ outline: "none", ml: 2 }}
              onClick={copyVersionsToClipboard}
            >
              <CopyIcon />
            </IconButton>
          </Grid>
        </Grid>
      </DialogComponent>
    );
  };

  return (
    <Box sx={{ bgcolor: theme.custom.colors.mediLightGray, flexShrink: 0 }}>
      <Container>
        <Stack direction="row" alignItems="center">
          {renderDialog()}
          <Box sx={{ alignSelf: "center" }}>
            <Typography
              sx={{
                color: theme.custom.colors.mediMagenta,
                fontWeight: "bold",
                my: 1.25,
              }}
            >
              medi. ich fühl mich besser.
            </Typography>
          </Box>
          <Box sx={{ ml: "auto" }}>
            <SwaggerLink onClick={() => setShowVersionInfo(true)}>
              Versionsinfo
            </SwaggerLink>
          </Box>
        </Stack>
      </Container>
    </Box>
  );
};
